import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByProperty',
  standalone: true,
})
export class FindByPropertyPipe implements PipeTransform {
  /**
   * Transforms an array of objects by finding the first element
   * that matches a given property name and value.
   * @param object - The array of objects to search within.
   * @param property - The property to match on.
   * @param value - The value to match the property against.
   * @returns The first matching object or undefined if not found.
   */
  transform<T>(object: T[], property: keyof T, value: unknown): T | undefined {
    return object.find((item) => item[property] === value);
  }
}
